import app from 'flarum/forum/app';
import UserPage from 'flarum/forum/components/UserPage';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import LinkButton from 'flarum/common/components/LinkButton';
const dayjs = window.dayjs;
export default class AchievementsPage extends UserPage {
  oninit(vnode) {
    super.oninit(vnode);
    this.achievements = [];
    this.totalCount = 0;
    this.loadingAchievements = true;
    this.loadUser(m.route.param('username'));

    // loadUser updates this.user asynchronously (or synchronously if cached)
    // We can use show() override or poll/check when user is available.
    // However, the cleanest way in Flarum is to call loadAchievements in show()
  }
  show(user) {
    super.show(user);
    this.loadAchievements();
  }
  loadAchievements() {
    if (!this.user) return;
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + "/nagusi/users/".concat(this.user.id(), "/achievements")
    }).then(response => {
      var _response$meta;
      this.achievements = response.data || [];
      this.totalCount = ((_response$meta = response.meta) == null ? void 0 : _response$meta.totalAchievements) || 0;
      this.loadingAchievements = false;
      m.redraw();
    }).catch(err => {
      this.loadingAchievements = false;
      console.error(err);
      m.redraw();
    });
  }
  content() {
    if (this.loading || this.loadingAchievements) {
      return m(LoadingIndicator, null);
    }
    const achievements = this.achievements;
    const totalCount = this.totalCount;
    return m("div", {
      className: "AchievementsPage"
    }, m("div", {
      className: "AchievementsStats",
      style: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: '15px',
        marginBottom: '20px'
      }
    }, m("div", {
      className: "AchievementsCounter",
      style: {
        margin: 0
      }
    }, m("span", {
      className: "CounterIcon"
    }, "\uD83C\uDFC6"), m("span", {
      className: "CounterValue"
    }, achievements.length, " / ", totalCount), m("span", {
      className: "CounterLabel"
    }, "Logros conseguidos")), m(LinkButton, {
      href: app.route('achievementsClassification'),
      className: "Button Button--primary",
      icon: "fas fa-list-ol"
    }, "Ver Clasificaci\xF3n")), m("div", {
      className: "AchievementsGrid"
    }, achievements.length > 0 ? achievements.map(item => {
      const achievement = item.attributes;
      return m("div", {
        className: "AchievementCard",
        key: achievement.slug
      }, m("div", {
        className: "AchievementIcon"
      }, achievement.image.startsWith('fa') ? m("i", {
        className: "".concat(achievement.image, " fa-2x")
      }) : achievement.image.startsWith('emoji:') ? m("span", {
        className: "AchievementEmoji"
      }, achievement.image.substring(6)) : m("img", {
        src: "/assets/extensions/nagusi-match-ratings/icons/".concat(achievement.image),
        alt: achievement.name
      }), achievement.level && m("span", {
        className: "AchievementLevelBadge"
      }, "N", achievement.level)), m("div", {
        className: "AchievementInfo"
      }, m("h3", {
        className: "AchievementName"
      }, achievement.name), achievement.description && m("p", {
        className: "AchievementDescription"
      }, achievement.description, achievement.slug === 'has-character-sheet' && this.user && m("span", {
        className: "AchievementSheetLink",
        style: {
          display: 'block',
          marginTop: '6px'
        }
      }, m(LinkButton, {
        href: app.route('userCharacterSheet', {
          username: this.user.username()
        }),
        className: "Button Button--link Button--small",
        icon: "fas fa-id-card",
        style: {
          padding: '0',
          fontWeight: 'bold'
        }
      }, app.translator.trans('nagusi-character-sheet.forum.directory.view_sheet_link')))), m("div", {
        className: "AchievementMeta",
        style: {
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginTop: '8px'
        }
      }, m("span", {
        className: "AchievementDate"
      }, dayjs(achievement.achievedAt).format('LL')), m("span", {
        className: "AchievementPercentage",
        style: {
          fontStyle: 'italic',
          fontSize: '11px',
          color: 'var(--muted-color)'
        }
      }, app.translator.trans('nagusi-achievements.forum.profile.achievement_percentage', {
        percentage: achievement.percentage
      })))));
    }) : m("p", {
      className: "NoAchievements"
    }, app.translator.trans('nagusi-achievements.forum.profile.no_achievements'))));
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/achievements/AchievementsPage', AchievementsPage);